import axios from 'axios';
export default {
	submit(data) {
		return axios.post('/apps/donation/merchant', data);
	}
};
